// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddProdCat_importCsvCard__GTPZt","addProdCatBtnContainer":"AddProdCat_addProdCatBtnContainer__DihpN"};